import React from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import { connect } from "react-redux"
import { Button } from "antd"
import * as actions from "../redux/actions"

class HeaderView extends React.Component {
	static propTypes = {
		data: PropTypes.objectOf(List),
		queryLoading: PropTypes.bool,
		showSoModal: PropTypes.func,
		querySOStatus: PropTypes.func,
		cleanSoData: PropTypes.func,
	}

	render() {
		return (
			<div style={{
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "space-between",
				paddingBottom: 24,
			}}>
				<div>
					<h1>GB335 Status</h1>
				</div>
				<div>
					<Button
						type="primary"
						icon="search"
						style={{ marginLeft: 24 }}
						loading={this.props.queryLoading}
						onClick={this.props.querySOStatus}
					>
						查詢
					</Button>
					<Button
						type="primary"
						icon="plus"
						style={{ marginLeft: 24 }}
						onClick={this.props.showSoModal}
					>
						新增
					</Button>
					<Button
						type="primary"
						icon="delete"
						style={{ marginLeft: 24 }}
						onClick={this.props.cleanSoData}
					>
						清除
					</Button>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		data: state.getIn(["main", "data"]),
		queryLoading: state.getIn(["main", "queryLoading"]),
	}
}

const mapDispatchToProps = {
	showSoModal: actions.showSoModal,
	querySOStatus: actions.querySOStatus,
	cleanSoData: actions.cleanSoData,
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderView)



// WEBPACK FOOTER //
// ./src/conponents/HeaderView.js